import { Card, Tabs } from 'antd';
import React, { useState } from 'react'
import { tabList } from './tabList';
import { useAdminUsuarios } from '../../../Hooks/Admin';

export const Usuarios = () => {
    const [activeTabKey, setActiveTabKey] = useState("lista");
    const [dataUser, setDataUser] = useState(null)
    const formularioHook = useAdminUsuarios({
        key: activeTabKey,
        setKey: setActiveTabKey,
        setDataUser: setDataUser,
        dataUser: dataUser
    });

    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    return (
        <Card style={{ width: "100%" }}>
            <Tabs
                items={tabList(setActiveTabKey, activeTabKey)}
                activeKey={activeTabKey}
                onChange={onTabChange}
                tabProps={{
                    size: "small",
                }}
            />
        </Card>
    );
}
